import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { AssignationFileData, FileData } from "../../../models/util/claims";

@Component({
  selector: "app-modal-upload-images",
  templateUrl: "./modal-upload-images.component.html",
  styleUrls: ["./modal-upload-images.component.scss"],
})
export class ModalUploadImagesComponent {
  uploads: FileData[] = [];
  @Input() multipleUpload: boolean = true;
  @Input() textTypeFiles: string = 'XML-PDF-JPG';
  @Input() typeDocumentValid: string = 'image/jpeg,image/jpg,application/pdf,text/xml';
  @Input() modalClaims: boolean = false;
  @Output() close = new EventEmitter<any>();
  @Output() sendFiles = new EventEmitter<FileData[]>();
  files: File[] = [];

  public statusUploadFile: 'error' | 'success' | 'warning' | null = null;
  public messageActionUpload: string = '';

  constructor(private spinner: NgxSpinnerService) {}

  onSelect(event) {
    let ex;
    for (let element of event.addedFiles) {
      console.log(element); 

      if (element.size > 8000000) {
        this.statusUploadFile = 'error';
        this.messageActionUpload = 'Sobrepasa el tamaño máximo 8Mb'
        return;
        break;
      }
      
      if (element.size == 0) {
        this.statusUploadFile = 'error';
        this.messageActionUpload = 'Asegúrate que la información no esté cargada desde un archivo comprimido (.zip, .rar).'
        return;
      }
    }

    if ( event.addedFiles.length > 0) {
      // @ts-ignore
      this.files.push(...event.addedFiles);
      this.statusUploadFile = 'success';
      this.messageActionUpload = 'Archivo cargado correctamente.'
    }
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
    this.statusUploadFile = null;
    this.messageActionUpload = ''
  }

  closeModal() {
    this.statusUploadFile = null;
    this.messageActionUpload = ''
    this.close.emit();
  }

  async saveDataFiles() {
    this.spinner.show();

    if (this.files.length > 0) {
      for (let element of this.files) {
        console.log(element);
        this.uploads.push({
          fileName: element.name,
          fileExtension: element.type,
          image: await this.toBase64(element),
        });
      }
    }
    this.sendFiles.emit(this.uploads);
    this.closeModal();
    this.spinner.hide();
  }

  async toBase64(element) {
    let doc = await this.convertFile(element);
    let docSend = doc.split(",");
    //console.log(docSend[1])
    return docSend[1];
  }

  convertFile(file: File): any {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => resolve(reader.result);

      reader.onerror = (error) => reject(error);
    });
  }
}
